module.exports = __webpack_public_path__ + "static/media/Choose_report_black.326efb33.svg";